module.exports = __webpack_public_path__ + "img/CATEGORY ICON-04.6d01e8fa.png";